module.exports = __webpack_public_path__ + "static/media/PlitviceLakes_Croatia_1.94002010.jpg";